import React, { useState } from "react";
import TrackVisibility from "react-on-screen";

import { FaGlobe, FaNodeJs, FaReact } from "react-icons/fa";
import { BiLogoMongodb } from "react-icons/bi";
import { SiMicrosoftsqlserver, SiMysql, SiTailwindcss } from "react-icons/si";
import { RiJavascriptFill } from "react-icons/ri";
import { BsGit } from "react-icons/bs";
import { AiFillGithub } from "react-icons/ai";

import Expressjs from "../../assets/icons/express.png";
import MaterialUI from "../../assets/icons/material ui.png";
import dotnetcore from "../../assets/icons/dotnetcore.png";
import CursorIcon from "../../assets/icons/cursor.png";
import AntigravityIcon from "../../assets/icons/antigravity.png";
import SupabaseIcon from "../../assets/icons/supabase.png";
import N8nIcon from "../../assets/icons/n8n.png";
import NextjsIcon from "../../assets/icons/nextjs.png";
import FirebaseIcon from "../../assets/icons/firebase.png";
import VercelIcon from "../../assets/icons/vercel.png";
import RazorpayIcon from "../../assets/icons/razorpay.png";
import CashfreeIcon from "../../assets/icons/cashfree.png";
import StripeIcon from "../../assets/icons/stripe.png";

const filterTabs = [
  { id: "all", label: "All Skills" },
  { id: "fullstack", label: "Full-Stack & Core" },
  { id: "ai-agentic", label: "AI & Agentic Tools" },
  { id: "payment", label: "Payment Integration" },
];

const skills = [
  {
    icon: <FaReact size={32} />,
    color: "rgb(0, 201, 247)",
    name: "React",
    categories: ["fullstack"],
  },
  {
    icon: <img src={NextjsIcon} alt="Next.js" />,
    name: "Next.js",
    categories: ["fullstack"],
  },
  {
    icon: <FaNodeJs size={32} />,
    color: "green",
    name: "NodeJs",
    categories: ["fullstack"],
  },
  {
    icon: <img src={Expressjs} alt="Express Js" />,
    name: "Express Js",
    categories: ["fullstack"],
  },
  {
    icon: <BiLogoMongodb size={32} />,
    color: "green",
    name: "MongoDB",
    categories: ["fullstack"],
  },
  {
    icon: <SiTailwindcss size={32} />,
    color: "#06B6D4",
    name: "TailwindCSS",
    categories: ["fullstack"],
  },
  {
    icon: <img src={MaterialUI} alt="Material UI" />,
    name: "MaterialUI",
    categories: ["fullstack"],
  },
  {
    icon: <RiJavascriptFill size={32} />,
    color: "#ee9d03",
    name: "JavaScript",
    categories: ["fullstack"],
  },
  {
    icon: <img src={dotnetcore} alt=".NET Core" />,
    name: ".NET Core",
    categories: ["fullstack"],
  },
  {
    icon: <FaGlobe size={32} />,
    color: "rgb(82, 35, 201)",
    name: "Web APIs",
    categories: ["fullstack"],
  },
  {
    icon: <SiMicrosoftsqlserver size={32} />,
    color: "purple",
    name: "MS-SQL",
    categories: ["fullstack"],
  },
  {
    icon: <SiMysql size={32} />,
    color: "#0846a8",
    name: "My-SQL",
    categories: ["fullstack"],
  },
  {
    icon: <BsGit size={32} />,
    color: "#f14f07",
    name: "Git",
    categories: ["fullstack"],
  },
  {
    icon: <AiFillGithub className="github" size={32} />,
    color: "black",
    name: "GitHub",
    categories: ["fullstack"],
  },
  {
    icon: <img src={VercelIcon} alt="Vercel" />,
    name: "Vercel",
    categories: ["fullstack"],
  },
  {
    icon: <img src={CursorIcon} alt="Cursor" />,
    name: "Cursor",
    categories: ["ai-agentic"],
  },
  {
    icon: <img src={AntigravityIcon} alt="Antigravity" />,
    name: "Antigravity",
    categories: ["ai-agentic"],
  },
  {
    icon: <img src={N8nIcon} alt="n8n" />,
    name: "n8n",
    categories: ["ai-agentic"],
  },
  {
    icon: <img src={SupabaseIcon} alt="Supabase" />,
    name: "Supabase",
    categories: ["ai-agentic"],
  },
  {
    icon: <img src={FirebaseIcon} alt="Firebase" />,
    name: "Firebase",
    categories: ["ai-agentic"],
  },
  {
    icon: <img src={RazorpayIcon} alt="Razorpay" />,
    name: "Razorpay",
    categories: ["payment"],
  },
  {
    icon: <img src={CashfreeIcon} alt="Cashfree" />,
    name: "Cashfree",
    categories: ["payment"],
  },
  {
    icon: <img src={StripeIcon} alt="Stripe" />,
    name: "Stripe",
    categories: ["payment"],
  },
];

function Skills() {
  const [activeTab, setActiveTab] = useState("all");

  const currentYear = new Date().getFullYear();
  const itExperience = currentYear - 2021;
  const managerYears = currentYear - 2023;

  const filteredSkills =
    activeTab === "all"
      ? skills
      : skills.filter((skill) => skill.categories.includes(activeTab));

  return (
    <>
      <p
        className="mb-4"
        style={{ fontSize: "15px", lineHeight: "1.8", color: "#555" }}
      >
        Over my <strong style={{ color: "#222" }}>{itExperience}+ Years</strong> in IT—spanning hands-on full-stack engineering across diverse project-by-project tech stacks and <strong style={{ color: "#222" }}>{managerYears}+ Years</strong> as Engineering Manager at <strong style={{ color: "#222" }}>TECHUNIQUEIIT</strong>—I have built diverse, scalable web applications customized to each project's needs. As the global industry rapidly shifts towards Artificial Intelligence, I have actively expanded my expertise into <strong style={{ color: "#FF5959" }}>Agentic AI & intelligent automation</strong>—combining robust full-stack fundamentals with cutting-edge tools like Cursor, Google Antigravity, n8n workflows, and modern cloud backends to architect faster, smarter software.
      </p>

      {/* Interactive Tabs */}
      <ul className="skills-filter">
        {filterTabs.map((tab) => (
          <li
            key={tab.id}
            className={activeTab === tab.id ? "current" : ""}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </li>
        ))}
      </ul>

      <TrackVisibility once>
        <div className="tech-chips-for-skill" key={activeTab}>
          {filteredSkills.map((skill, index) => (
            <span key={skill.name} className="tech-chip-for-skill">
              <i style={{ color: skill.color }}>
                {skill.icon}
              </i>
              {skill.name}
            </span>
          ))}
        </div>
      </TrackVisibility>
    </>
  );
}

export default Skills;
